import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { AnimatedSection } from './ui/AnimatedSection';
import { SparkleDecoration } from './ui/SparkleDecoration';
import { Check, Flame } from 'lucide-react';
export function PricingSection() {
  const [selected, setSelected] = useState<'basic' | 'pro'>('pro');
  const [showBump, setShowBump] = useState(false);
  const [bumpAdded, setBumpAdded] = useState(false);
  const handleSelect = (option: 'basic' | 'pro') => {
    setSelected(option);
    setShowBump(true);
  };
  const handleCTA = () => {
    setShowBump(true);
  };
  const BASIC_CHECKOUT_URL = 'https://checkout.infinita-mente.online/checkouts/cn/hWNA2slddAdn04Dalz8dkOaf/es-ar?_r=AQABwlgFuWeX07-GEMXps_YN3_lmOCe1uQR9YhppzanwCJ4&preview_theme_id=138558668898:1';
  const BASIC_BUMP_CHECKOUT_URL = 'https://checkout.infinita-mente.online/checkouts/cn/hWNA2te8vKy8g84MUvq28C93/es-ar?_r=AQABKdRMp37h0C9o9ggVp7IqOR7QVanICsnnf1fe4Zs2md0&preview_theme_id=138558668898:1';
  const PRO_CHECKOUT_URL = 'https://checkout.infinita-mente.online/checkouts/cn/hWNA2xqq7Ay1vd60ycjTCUoT/es-ar?_r=AQABcxpwbCmmzpxTa4NJahTSIHWdLeRHzVCoZHU4j_U5Jhs&preview_theme_id=138558668898:1';
  const PRO_BUMP_CHECKOUT_URL = 'https://checkout.infinita-mente.online/checkouts/cn/hWNA2u9w2kKN2zXJ2B95LlGT/es-ar?_r=AQABWBW2SIRSLAkWuUSJrYsFRYm5XEkwyuyEVpOm4PXootc&preview_theme_id=138558668898:1';
  const handleContinue = () => {
    // Track InitiateCheckout event with Meta Pixel
    if ((window as any).fbq) {
      ;
      (window as any).fbq('track', 'InitiateCheckout', {
        content_name: selected === 'pro' ? 'Mega Pack Pro' : 'Mega Pack',
        content_category: 'Mama Sin Estres',
        value: selected === 'pro' ? 29999 : 19999,
        currency: 'ARS',
        content_ids: [selected === 'pro' ? 'mega-pack-pro' : 'mega-pack'],
        num_items: 1,
        contents: [{
          id: selected === 'pro' ? 'mega-pack-pro' : 'mega-pack',
          quantity: 1,
          item_price: selected === 'pro' ? 29999 : 19999
        }]
      });
    }
    if (selected === 'basic' && bumpAdded) {
      window.open(BASIC_BUMP_CHECKOUT_URL, '_blank');
    } else if (selected === 'basic') {
      window.open(BASIC_CHECKOUT_URL, '_blank');
    } else if (selected === 'pro' && bumpAdded) {
      window.open(PRO_BUMP_CHECKOUT_URL, '_blank');
    } else if (selected === 'pro') {
      window.open(PRO_CHECKOUT_URL, '_blank');
    }
    setShowBump(false);
  };
  return <section id="precio" className="pt-32 pb-32 relative overflow-hidden bg-gradient-to-b from-burgundy via-burgundy to-[#4a1520]" data-id="element-191">
      {/* Wavy Top Divider — cream blending from Testimonials */}
      <div className="absolute top-0 left-0 w-full overflow-hidden leading-none z-10" data-id="element-192">
        <svg className="relative block w-full h-[60px] md:h-[120px]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none" data-id="element-193">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" fill="#FDF6F0" data-id="element-194" />
        </svg>
      </div>

      {/* Wavy Bottom Divider — blending into Guarantee section (rose/20 on cream ≈ #FBE6DF) */}
      <div className="absolute bottom-0 left-0 w-full overflow-hidden leading-none z-10" data-id="element-195">
        <svg className="relative block w-full h-[60px] md:h-[120px]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none" style={{
        transform: 'scaleY(-1)'
      }} data-id="element-196">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" fill="#FBE6DF" data-id="element-197" />
        </svg>
      </div>

      {/* Sparkle Decorations — matching the landing's style */}
      <div className="absolute top-24 left-6 opacity-40" data-id="element-198">
        <SparkleDecoration size={35} color="#F2A59D" data-id="element-199" />
      </div>
      <div className="absolute top-40 right-8 opacity-50" data-id="element-200">
        <SparkleDecoration size={50} color="#E8735A" type="star" data-id="element-201" />
      </div>
      <div className="absolute bottom-32 left-10 opacity-30" data-id="element-202">
        <SparkleDecoration size={45} color="#F2A59D" type="star" data-id="element-203" />
      </div>
      <div className="absolute bottom-48 right-12 opacity-40" data-id="element-204">
        <SparkleDecoration size={30} color="#E8735A" data-id="element-205" />
      </div>
      <div className="absolute top-1/2 left-1/4 opacity-20" data-id="element-206">
        <SparkleDecoration size={55} color="#FFFFFF" type="star" data-id="element-207" />
      </div>
      <div className="absolute top-1/3 right-1/4 opacity-25" data-id="element-208">
        <SparkleDecoration size={28} color="#FFFFFF" data-id="element-209" />
      </div>
      <div className="absolute bottom-20 left-1/3 opacity-35" data-id="element-210">
        <SparkleDecoration size={22} color="#F2A59D" type="star" data-id="element-211" />
      </div>
      <div className="absolute top-28 left-1/2 opacity-20" data-id="element-212">
        <SparkleDecoration size={40} color="#E8735A" data-id="element-213" />
      </div>

      <div className="max-w-md mx-auto px-4 sm:px-6 relative z-10" data-id="element-214">
        <AnimatedSection className="text-center mb-8" data-id="element-215">
          <div className="inline-block bg-white/15 text-white font-bold px-5 py-1.5 rounded-full mb-4 border border-white/20 text-sm backdrop-blur-sm" data-id="element-216">
            ⏰ OFERTA ESPECIAL LIMITADA
          </div>
          <h2 className="text-2xl md:text-3xl font-serif font-bold text-white" data-id="element-217">
            Elegí tu opción
          </h2>
        </AnimatedSection>

        <AnimatedSection delay={0.1} data-id="element-218">
          <div className="bg-rose/25 backdrop-blur-sm rounded-2xl p-4 shadow-2xl overflow-hidden relative border border-rose/30" data-id="element-219">
            {/* Sparkle decorations */}
            <div className="absolute top-3 right-3 opacity-40" data-id="element-220">
              <SparkleDecoration size={16} color="#F2A59D" type="star" data-id="element-221" />
            </div>

            {/* Option 1 - Basic */}
            <button onClick={() => handleSelect('basic')} className={`w-full rounded-xl p-4 mb-3 flex items-center gap-3 transition-all duration-200 text-left ${selected === 'basic' ? 'bg-coral/25 border-2 border-coral' : 'bg-white/10 border-2 border-transparent hover:bg-white/15'}`} data-id="element-222">
              <div className={`w-5 h-5 rounded-full border-2 flex-shrink-0 flex items-center justify-center ${selected === 'basic' ? 'border-coral bg-coral' : 'border-white/40'}`} data-id="element-223">
                {selected === 'basic' && <Check size={12} className="text-white" strokeWidth={3} data-id="element-224" />}
              </div>
              <div className="flex-1 min-w-0" data-id="element-225">
                <h3 className="text-white font-bold text-sm" data-id="element-226">MEGA PACK</h3>
                <p className="text-white/60 text-xs" data-id="element-227">
                  6 Tomos + 6 bonos gratis
                </p>
              </div>
              <div className="text-right flex-shrink-0" data-id="element-228">
                <span className="text-white/40 line-through text-xs block" data-id="element-229">
                  $39.998
                </span>
                <span className="text-white font-black text-xl" data-id="element-230">$19.999</span>
              </div>
            </button>

            {/* "MÁS ELEGIDO" + Savings badge */}
            <div className="flex items-center justify-center gap-2 mb-3" data-id="element-231">
              <span className="bg-coral text-white text-[10px] font-bold px-3 py-1 rounded-full uppercase tracking-wider" data-id="element-232">
                ⭐ Más elegido
              </span>
              <span className="bg-rose/40 text-white text-[10px] font-bold px-3 py-1 rounded-full uppercase tracking-wider" data-id="element-233">
                Ahorrás $20.000
              </span>
            </div>

            {/* Option 2 - Pro */}
            <button onClick={() => handleSelect('pro')} className={`w-full rounded-xl p-4 mb-4 flex items-center gap-3 transition-all duration-200 text-left ${selected === 'pro' ? 'bg-coral/25 border-2 border-coral' : 'bg-white/10 border-2 border-transparent hover:bg-white/15'}`} data-id="element-234">
              <div className={`w-5 h-5 rounded-full border-2 flex-shrink-0 flex items-center justify-center ${selected === 'pro' ? 'border-coral bg-coral' : 'border-white/40'}`} data-id="element-235">
                {selected === 'pro' && <Check size={12} className="text-white" strokeWidth={3} data-id="element-236" />}
              </div>
              <div className="flex-1 min-w-0" data-id="element-237">
                <h3 className="text-white font-bold text-sm" data-id="element-238">MEGA PACK PRO</h3>
                <p className="text-white/60 text-xs" data-id="element-239">
                  6 Tomos+ 6 bonos + Método Pro: Mamá Imparable
                </p>
              </div>
              <div className="text-right flex-shrink-0" data-id="element-240">
                <span className="text-white/40 line-through text-xs block" data-id="element-241">
                  $49.998
                </span>
                <span className="text-white font-black text-xl" data-id="element-242">$29.999</span>
              </div>
            </button>

            {/* CTA Button */}
            <button onClick={handleCTA} className="w-full bg-emerald-500 text-white py-3.5 rounded-full font-bold text-base hover:scale-[1.02] active:scale-[0.98] transition-transform duration-200 shadow-lg" data-id="element-243">
              SÍ, QUIERO MI PACK HOY →
            </button>

            {/* Trust line */}
            <p className="text-center text-white/50 text-[10px] mt-3" data-id="element-244">
              La opción más elegida por mamás que decidieron organizarse
            </p>
          </div>
        </AnimatedSection>

        {/* Trust badges */}
        <AnimatedSection delay={0.2} className="mt-5" data-id="element-245">
          <div className="flex flex-wrap items-center justify-center gap-2" data-id="element-246">
            <span className="bg-white/15 border border-white/25 text-white font-semibold text-xs px-3 py-1.5 rounded-full" data-id="element-247">
              📄 100% PDF
            </span>
            <span className="bg-white/15 border border-white/25 text-white font-semibold text-xs px-3 py-1.5 rounded-full" data-id="element-248">
              ⚡ Acceso inmediato
            </span>
            <span className="bg-white/15 border border-white/25 text-white font-semibold text-xs px-3 py-1.5 rounded-full" data-id="element-249">
              🛡️ Garantía 7 días
            </span>
            <span className="bg-white/15 border border-white/25 text-white font-semibold text-xs px-3 py-1.5 rounded-full" data-id="element-250">
              💳 Mercado Pago
            </span>
          </div>
        </AnimatedSection>
      </div>

      {/* Order Bump Modal Overlay */}
      <AnimatePresence data-id="element-251">
        {showBump && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.25
      }} className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-end sm:items-center justify-center p-4" onClick={() => setShowBump(false)} data-id="element-252">
            <motion.div initial={{
          y: 60,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} exit={{
          y: 60,
          opacity: 0
        }} transition={{
          duration: 0.3,
          ease: 'easeOut'
        }} className="bg-burgundy rounded-2xl p-5 w-full max-w-sm shadow-2xl relative border border-white/10" onClick={e => e.stopPropagation()} data-id="element-253">
              {/* Header */}
              <div className="text-center mb-4" data-id="element-254">
                <div className="flex items-center justify-center gap-2 mb-2" data-id="element-255">
                  <Flame size={20} className="text-coral" data-id="element-256" />
                  <h3 className="text-white font-bold text-base" data-id="element-257">
                    ¡ESPERÁ! OFERTA EXCLUSIVA
                  </h3>
                  <Flame size={20} className="text-coral" data-id="element-258" />
                </div>
                <p className="text-white/70 text-sm" data-id="element-259">
                  Antes de finalizar, ¿querés agregar esto a tu compra?
                </p>
              </div>

              {/* Bump product */}
              <button onClick={() => setBumpAdded(!bumpAdded)} className={`w-full rounded-xl p-4 flex items-start gap-3 transition-all duration-200 text-left mb-4 ${bumpAdded ? 'bg-coral/20 border-2 border-coral' : 'bg-white/10 border-2 border-white/20 hover:bg-white/15'}`} data-id="element-260">
                <div className={`w-5 h-5 rounded border-2 flex-shrink-0 mt-0.5 flex items-center justify-center ${bumpAdded ? 'border-coral bg-coral' : 'border-white/40'}`} data-id="element-261">
                  {bumpAdded && <Check size={12} className="text-white" strokeWidth={3} data-id="element-262" />}
                </div>
                <div className="flex-1" data-id="element-263">
                  <div className="flex items-center justify-between mb-1" data-id="element-264">
                    <h4 className="text-white font-bold text-sm" data-id="element-265">
                      Resolve la Cena en 15 minutos
                    </h4>
                    <span className="text-coral font-black text-lg" data-id="element-266">
                      $5.999
                    </span>
                  </div>
                  <p className="text-white/60 text-xs leading-relaxed" data-id="element-267">
                    Agregá este producto exclusivo a tu pedido con un solo click
                  </p>
                </div>
              </button>

              <p className="text-white/40 text-[10px] text-center mb-4" data-id="element-268">
                Hacé click para agregar a tu pedido
              </p>

              {/* Continue buttons */}
              <button onClick={handleContinue} className="w-full bg-emerald-500 text-white py-3 rounded-full font-bold text-sm hover:scale-[1.02] active:scale-[0.98] transition-transform duration-200 shadow-lg mb-2" data-id="element-269">
                {bumpAdded ? 'AGREGAR Y CONTINUAR →' : 'CONTINUAR SIN AGREGAR →'}
              </button>

              <button onClick={() => setShowBump(false)} className="w-full text-white/50 text-xs py-2 hover:text-white/70 transition-colors" data-id="element-270">
                ← Volver atrás
              </button>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </section>;
}